<style lang="scss" scoped>
.font-weight {
  font-weight: 800;
}
</style>
<template>
  <div>
    <compWrapper title="新品推荐"
                 theme="primary">
      <compFormQuery class="margin-top-15 margin-right-15"
                     :formdata="getBase"
                     :value="formData"
                     :labelWidth="120"
                     placeholder="--"></compFormQuery>
    </compWrapper>
    <!-- 操作历史 -->
    <!-- <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog :data="logList" ></compLog>
        </compWrapper> -->

    <vLoading size="large"
              transfer
              :loading="loading"></vLoading>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpGetListingOne } from "@/service/setting"


export default {
  props: ['activeid', 'querytype'],
  data () {
    return {
      type: this.$route.params.type || this.querytype,
      id: this.$route.query.id || this.activeid,
      formData: {
      },
      logList: [],
      downcateoryList: [],
      loading: false,
      titleName: '',
    }
  },
  components: {
    compWrapper: () => import("@components/templates/wrapper"),
    compFormQuery: () => import("@components/templates/formquery"),
    compFormEdit: () => import("@components/templates/formedit"),
  },
  created () {
    this.update();

  },
  computed: {
    ...mapGetters('diction', ['getNewProductList', 'getAllProductPerson']),
    ...mapState('boss', ['accountTypes']),
    getBase () {
      return [
        {
          label: "图片",
          tag: "div",
          render: (h, props) => {
            if (this.formData.imageLink) {
              return <img src={this.formData.imageLink} style="height:70px;" />
            } else {
              return <img src='https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1599645172165&di=b13a3514d4c7c3c8f5da1c03e6574402&imgtype=0&src=http%3A%2F%2Fimages.669pic.com%2Felement_pic%2F3%2F88%2F77%2F52%2F63160fa6edcfde1b73bafadf9be77e8d.jpg' style="height:70px;" />
            }
          },
          show: this.type == 'query'
        },
        {
          label: "店铺名称",
          key: "channelFlag",
          tag: "vInput",
        },
        {
          label: "国家",
          key: 'country',
          tag: "vInput",
        },
        {
          label: "是否店铺对应关系",
          key: "cancelReason",
          valueText: this.formData.isChannelRelate == 0 ? '否' : '是',
          required: false,
        },
        {
          label: "sku",
          key: 'sellerSku',
          tag: "vInput",
        },
        {
          label: "ASIN",
          key: 'asin',
          tag: "vInput",
        },
        {
          label: "FNSKU",
          key: 'fnsku',
          tag: "vInput",
        },
        {
          label: "List Price",
          key: 'listPrice',
          tag: "vInput",
        },
        {
          label: "Title",
          key: 'title',
          tag: "vInput",
        },
        {
          label: "上架日期",
          key: 'openDate',
          tag: "vInput",
        },
        {
          label: "排名",
          key: 'rank',
          tag: "vInput",
        },
        {
          label: "Category",
          key: 'category',
          tag: "vInput",
        },
        {
          label: "Manufacturer",
          key: 'manufacturer',
          tag: "vInput",
        },
        {
          label: "Color",
          key: 'color',
          tag: "vInput",
        },
        {
          label: "图片链接",
          key: 'imageLink',
          tag: "vInput",
        },
        {
          label: "FBA库存量",
          key: 'fbaInventory',
          tag: "vInput",
        },
        {
          label: "最近一次同步时间",
          key: 'lastestSyncTime',
          tag: "vInput",
        },
        {
          label: "更新时间",
          key: 'updatedAt',
          tag: "vInput",
        },
      ]
    },
  },
  methods: {
    update () {
      this.loading = true;
      HttpGetListingOne({
        id: this.id
      }).then(res => {
        this.formData = res.data;

        this.loading = false;
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
        this.loading = false;
      })
    },

    cancel () {
      this.$router.push({
        name: 'recommendList',
      })
    },
  }
}
</script>

